import {useEffect, useState} from 'react';

import {Select} from '@/components';
import {getCurrencyOptions} from '@/constants/formatters';
import type {CurrencySelectorProps} from '@/types';
import {AfriexCurrencyCode} from '@/types';

const CurrencySelector = ({
  fixedCurrency,
  value,
  label,
  onChange,
  className,
  ...props
}: CurrencySelectorProps) => {
  const [currency, setCurrency] = useState<AfriexCurrencyCode>(
    AfriexCurrencyCode.NGN,
  );

  useEffect(() => {
    if (fixedCurrency) {
      setCurrency(fixedCurrency);
    }
  }, [fixedCurrency]);

  useEffect(() => {
    if (value) {
      setCurrency(value);
    }
  }, [value]);

  const handleCurrencyChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const selectedCurrency = event.target.value as AfriexCurrencyCode;
    if (!selectedCurrency) {
      return;
    }
    setCurrency(selectedCurrency);
    onChange(event);
  };

  const containerProps = {
    ...props,
    ...(className && {className}),
  };
  return (
    <Select
      label={label}
      onChange={handleCurrencyChange}
      value={currency}
      name="currency"
      options={getCurrencyOptions(AfriexCurrencyCode)}
      placeholder="Filter by Status"
      {...containerProps}
    />
  );
};

export default CurrencySelector;
